import styled from "styled-components";

export const HeaderD = styled.header`
    /* width: 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #29903B;
    padding: 0px 0px;
    font-weight: 400;
       
    @media (max-width: 768px) {
        flex-direction: column; 
        width: 100%;
        margin: 0 auto;
        align-items: center;       
                 
    }       

    img {
        width: 200px;
        height: auto;
        padding: 5px 5px;
    
        @media (max-width: 768px) {
            display: flex; 
            width: 40%;
            height: auto;
            margin: 0 auto;
        }
    }
    

    .links {
        @media (max-width: 768px) {
            width: 100%;
            display: flex;            
            flex-direction: row;
            justify-content: center;
            text-align: center;
            align-items: center;
            background-color: #fff;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 0px;         
            
                        
        }
    }

    .links a {
        color: #FFF;
        text-decoration: none;
        font-size: 14;
        position: relative;
        padding: 0 10px;
        

        @media (max-width: 768px) {
            color: #4fc878 
                 
                
        }
    }
    .links a::after {
        content: "";
        position: absolute;
        background-color: #FFF;
        height: 3px;
        border-radius: 10px;
        width: 0;
        bottom: -10px;
        left: 0;
        transition: 0.3s;
    }
    .links a:hover::after {
        width: 100%;
    }
`;